import BaseCommand from "@/models/api/commands/BaseCommand";

export class SaveTradeTermToOtherOrderCommand extends BaseCommand {
  CommandName = "SaveTradeTermToOtherOrder";
  Command = undefined;
  constructor(sessionId: string, operationId: string) {
    super(sessionId, operationId);
  }
}
